import React, { useEffect, Suspense } from 'react';
import store from 'app/store';

import * as types from 'actions/action_types';
import { scope } from 'actions/Map/map.scope.action';
import { FormattedMessage } from 'react-intl';
// import { API } from '../../../API/manager';
import { pageScope } from '../../../constants/mapConstants';

import pageDataAPI from '../../../API/pageData.api';

import { retry } from '../../Utility/loadingChunkErrorHandler';

const List = React.lazy(() =>
  retry(() =>
    import(/* webpackChunkName: "listtourconteiner" */ '../List/list.container')
  )
);

// async function loadData() {
//   const [pub, my] = await Promise.all([
//     API.way.list.getAll('publicTours', {}),
//     API.way.list.getAll('myTours', { limit: 10000, mine_all: 1, page: 0 }),
//   ]);
//   const arr = [...pub.data.entities, ...my.data.entities].filter(
//     (obj, pos, arr) => {
//       return arr.map((mapObj) => mapObj.id).indexOf(obj.id) === pos;
//     }
//   );
//   return arr;
// }

const AllPublicTours = ({ page }) => {
  const cleanMap = () => {
    store.dispatch({
      type: types.FETCH_TOURS_PUBLIC_FULFILLED,
      payload: [],
    });
    store.dispatch({ type: types.FETCH_PREVIEW_DATA_CLEANE });
  };

  useEffect(() => {
    setTimeout(() => {
      store.dispatch((dispatch) => {
        dispatch({
          type: types.FETCH_TOURS_PUBLIC,
          payload: pageDataAPI.getPublicTours(),
        });
        dispatch(scope(pageScope.tour));
      });
    }, 100);
    return cleanMap;
  }, []);

  const getLabel = () => <FormattedMessage id="Tours" defaultMessage="Tours" />;

  return (
    page === 'list' && (
      <Suspense>
        <List label={getLabel()} />
      </Suspense>
    )
  );
};

const areEqual = () => {
  return false;
};

export default React.memo(AllPublicTours, areEqual);
